/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';

import {SettlementsRoutingModule} from './settlements-routing.module';
import {SettlementsMainPageComponentModule} from './settlements-main-page/settlements-main-page.component.module';
import {TableModule} from '../shared/table/table.module';
import {PaginationModule} from '../shared/pagination/pagination.module';

@NgModule({
    imports: [
        SettlementsRoutingModule,
        SettlementsMainPageComponentModule,
        TableModule,
        PaginationModule,
    ]
})

export class SettlementsModule {
}

